import { Guid } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { OrderNumber } from '@web/shared/module/shop';

@jsonObject
export class WarehouseRestockOrderResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: OrderNumber;
}
